import { useNavigate } from 'react-router-dom';
import {
    Card,
    Typography,
    Grid,
    CardActionArea,
    Box,
    Button,
    CircularProgress
} from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import { getCandidateById } from '../helper/Api_Helper';
import { getCandidateId } from '../helper/My_Helper';
import { useEffect, useState } from 'react';

const JoiningKit = () => {
    const navigate = useNavigate();

    const [onboardingDocs, setOnboardingDocs] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const candidateId = getCandidateId();

                if (!candidateId) {
                    console.warn("No candidate ID found");
                    setLoading(false);
                    return;
                }

                const response = await getCandidateById({
                    _id: candidateId,
                    scope_fields: ["onboarding_docs_stage", "onboarding_docs"]
                });
                setOnboardingDocs(response?.data?.onboarding_docs || []);
            } catch (error) {
                console.error("Error fetching candidate data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const joiningKitTabs = onboardingDocs
        .filter(
            doc =>
                doc.doc_category &&
                doc.doc_category.trim().toLowerCase() === "joining kit"
        )
        .map(doc => ({
            title: doc.doc_name,
            doc: doc.doc_name,
            status: doc.status
        }));

    const DashboardCard = ({ title, path, status }) => (
        <Grid item xs={12} sm={6} md={4}>
            <Card
                sx={{
                    height: '100%',
                    transition: '0.3s',
                    '&:hover': { transform: 'scale(1.02)' }
                }}
            >
                <CardActionArea
                    onClick={() => navigate(path)}
                    sx={{ height: '100%', p: 2 }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}
                    >
                        <WorkIcon sx={{ fontSize: 40, color: '#1976d2', mb: 2 }} />

                        <Typography variant="h6" fontWeight="bold">
                            {title}
                        </Typography>

                        <Typography
                            variant="caption"
                            sx={{
                                mt: 1,
                                color:
                                    status === "complete"
                                        ? "green"
                                        : "orange"
                            }}
                        >
                            {status}
                        </Typography>
                    </Box>
                </CardActionArea>
            </Card>
        </Grid>
    );

    return (
        <div className="maincontent" style={{ padding: '20px' }}>
            <div className="container">

                {/* Back Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            if (window.history.length > 1) {
                                navigate(-1);
                            } else {
                                navigate("/dashboard");
                            }
                        }}
                    >
                        Back
                    </Button>
                </Box>

                {/* Content */}
                <Grid container spacing={3}>


                    {loading && (
                        <Box sx={{ width: '100%', textAlign: 'center', mt: 4 }}>
                            <CircularProgress />
                        </Box>
                    )}

                    {/* ❌ No Data */}
                    {!loading && joiningKitTabs.length === 0 && (
                        <Typography sx={{ ml: 2 }}>
                            No Joining Kit documents found
                        </Typography>
                    )}

                    {!loading &&
                        joiningKitTabs.length > 0 &&
                        joiningKitTabs.map((tab, index) => (
                            <DashboardCard
                                key={`${tab.doc}-${index}`}
                                title={tab.title}
                                status={tab.status}
                                path={`/approval-documents?doc_name=${encodeURIComponent(tab.doc)}`}
                            />
                        ))}
                </Grid>
            </div>
        </div>
    );
};

export default JoiningKit;
